export default "/images/arrow-right.svg?87451d8a8e466384c9ed59b95bd4b90a";